import React from 'react'
import Helmet from 'react-helmet'
import autoBind from 'react-autobind'

import PressContactForm from '../components/PressContactForm'
import Header from "../components/Nav.js";
import './Press.css'
import './Heritage.css'

class PressPage extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
      display:true,
    };
    autoBind(this);
  }

  handleClick(){
    this.setState({display: !this.state.display});
  }

  render(){
  const { title, text, email } = this.props.page
  return (
      <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header />
      <div className="heritageTitle">{title}</div>
      <div style={{minHeight:"calc(100vh - 390px)",width:"calc(100% - 60px)",margin:"0 auto"}}>
        <div className="pressText">{text}</div>
        <div className="pressEmail">{email}</div>
        <div className="pressContactFormWrapper">
          <PressContactForm onClick={this.handleClick} location="contact" />
        </div>
      </div>
    </div>
  )
}}


export default PressPage;



// WEBPACK FOOTER //
// ./src/views/Press.js